module.exports = __webpack_public_path__ + "img/resource-science.133333f5.png";